import './SearchBoxTable.less';
import React from 'react';

function SearchBoxTable({ children, className = 'px-8 py-10', onClick }) {
    return (
        <div className={`search-box-table flex br-radius-4 fs-14 ${className}`} onClick={onClick}>
            {children}
        </div>
    );
}

export default SearchBoxTable;
